import {FormProvider} from 'react-hook-form';
import {getInitialValues} from '../AutoSection';
import {getSchema} from '../AutoSection';
import {getSections} from '../AutoSection';
import {AutoField} from '../fields';
import {useNonPersistentFormMethods} from '../hooks';
import fields from './fields';
import {usePostBillingAddress} from 'hooks/usePostEndpoint';
import FormDialog from '../FormDialog';
import {useContext, useEffect, useState} from 'react';
import {AppCtx} from 'context/AppContext';
import {Button, CircularProgress, Grid} from '@material-ui/core';
import {UserContext} from 'context/UserContext';

const BillingForm = ({billingInfo, setBillingInfo}) => {
    // const [billingInfo, setBillingInfo] = useState(existingBillingInfo);
    const sections = getSections(fields);
    const sectionFields = sections['Billing Information'];
    const [formComplete, setFormComplete] = useState(false);
    const {setSnackProps, setSnackOpen} = useContext(AppCtx);

    const methods = useNonPersistentFormMethods({
        initialValues: getInitialValues(billingInfo, sectionFields, fields),
        schema: getSchema(sectionFields, fields),
    });
    const {errors} = methods;

    const {post, submissionInProgress, result, error} = usePostBillingAddress();

    const onSubmit = e => {
        e.preventDefault();
        if (Object.keys(errors).length === 0) {
            post(methods.getValues());
        }
    };

    useEffect(() => {
        if (result) {
            setBillingInfo(result);
            setSnackOpen(true);
            setSnackProps({
                severity: 'success',
                message: 'Billing Address Updated!',
            });
            setFormComplete(true);
        }
        if (error) {
            setSnackOpen(true);
            setSnackProps({
                severity: 'warning',
                message: 'Something went wrong',
            });
        }
        // eslint-disable-next-line
    }, [result, error]);

    return (
        <FormProvider {...methods}>
            <form onSubmit={onSubmit}>
                {sectionFields.map(field => (
                    <AutoField
                        field={fields[field]}
                        name={`${field}`}
                        key={`${field}`}
                        disabled={formComplete}
                    />
                ))}
                <Button
                    variant='contained'
                    color='primary'
                    type='submit'
                    fullWidth
                    disabled={submissionInProgress || formComplete}
                >
                    {submissionInProgress ? (
                        <CircularProgress />
                    ) : formComplete ? (
                        'Changes Saved!'
                    ) : (
                        'Save Changes'
                    )}
                </Button>
            </form>
        </FormProvider>
    );
};

const BillingFormDialog = ({buttonText, ...buttonProps}) => {
    const sections = getSections(fields);
    const sectionFields = sections['Billing Information'];
    const {billingInfo, actions} = useContext(UserContext);

    const methods = useNonPersistentFormMethods({
        initialValues: getInitialValues(billingInfo, sectionFields, fields),
        schema: getSchema(sectionFields, fields),
    });

    const {post, result, submissionInProgress, error, reset} =
        usePostBillingAddress();

    useEffect(() => {
        methods.reset(billingInfo);
        // eslint-disable-next-line
    }, [billingInfo]);

    useEffect(() => {
        if (result) {
            actions.updateBillingInfo(result);
        }
        //eslint-disable-next-line
    }, [result]);

    return (
        <FormProvider {...methods}>
            <FormDialog
                title='Billing Address'
                inProgress={submissionInProgress}
                success={result}
                error={error}
                buttonProps={buttonProps}
                buttonText={buttonText}
                onSubmit={methods.handleSubmit(data => post(data))}
                reset={reset}
            >
                <Grid container spacing={2}>
                    {sectionFields.map((field, index) => (
                        <Grid item xs={12} key={field}>
                            <AutoField
                                field={fields[field]}
                                name={`${field}`}
                                key={`${field}`}
                                autoFocus={index === 0}
                            />
                        </Grid>
                    ))}
                </Grid>
            </FormDialog>
        </FormProvider>
    );
};

export default BillingForm;
export {BillingFormDialog};
